import { getPrivateKey } from './user.service';
import Orders from '../sidechain/handles/orderHandle';
import Reviews from '../sidechain/handles/reviewHandle';
import CustomError from './errors/CustomError';
import { status_response } from './constants';
import { elasticAddreview, elasticUpdateReview } from '../elasticsearch/elasticReview';
import { getUserProfile } from './profile.service';
import { changeReadStatusNotificationByOrder } from './notification.service';
import { NOTIFY_CATEGORY, NOTIFY_CONTENT_TYPE } from './constants';

/**
 * Check status review of a customer to shop: //0: cannot review, 1: can review, 2: already reviewed
 * @param {*} orderId order id
 * @return {*} status review
 */
const checkStatusReviewShop = async function(orderId) {
  try {
    checkNumber('orderId', orderId);
    const privateKey = await getPrivateKey();
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.checkStatusReviewShop(orderId);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Check status review of shop about a customer: //0: cannot review, 1: can review, 2: already reviewed
 * @param {*} orderId order id
 * @return {*} status review
 */
const checkStatusReviewCustomer = async function(orderId) {
  try {
    checkNumber('orderId', orderId);
    const privateKey = await getPrivateKey();
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.checkStatusReviewCustomer(orderId);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Customer add review about shop
 * @param orderId
 * @param {*} star
 * @param {*} comment
 */
const addReviewToShop = async function(orderId, star, comment) {
  try {
    checkNumber('orderId', orderId);
    checkStarInput(star);
    checkComment(comment);
    const privateKey = await getPrivateKey();
    const reviewHandle = new Reviews(privateKey);

    // Check can review before add
    const statusReview = await reviewHandle.checkStatusReviewShop(orderId);
    if (statusReview === 0) {
      throw new CustomError("doesn't have permit to review shop.", 'EF2143_Content');
    }
    if (statusReview === 2) {
      throw new CustomError('Already review this shop.', 'EF2145_Content');
    }

    const orderHandle = new Orders(privateKey);
    const order = await orderHandle.getOrderByID(orderId);
    if (order.shopAddr === order.cusAddr) {
      throw new CustomError('Cannot review by self.', 'EF2148_Content');
    }
    // Add review
    const data = await reviewHandle.addReviewToShop(orderId, star, comment);
    // try {
    //   await elasticAddreview({
    //     id: data.id,
    //     reviewType: CUSTOMER_REVIEW_SHOP,
    //     orderId: orderId,
    //     star: star,
    //     comment: comment,
    //     sendAddress: reviewHandle.getPublicAddress(),
    //     recipientAddress: data.recipientAddress,
    //     createdAt: new Date(data.createdAt * 1000),
    //     updatedAt: new Date(data.createdAt * 1000)
    //   });
    // } catch (e) {
    //   console.log(e);
    // }
    return {
      status: status_response.success,
      result: {
        data: data,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Shop add review about customer
 * @param {*} orderId
 * @param {*} star
 * @param {*} comment
 */
const addReviewToCustomer = async function(orderId, star, comment) {
  try {
    checkNumber('orderId', orderId);
    checkStarInput(star);
    checkComment(comment);
    const privateKey = await getPrivateKey();
    const reviewHandle = new Reviews(privateKey);

    // Check can review customer
    const statusReview = await reviewHandle.checkStatusReviewCustomer(orderId);
    if (statusReview === 0) {
      throw new CustomError('doesnt have permit to review shop.', 'EF2143_Content');
    }
    if (statusReview === 2) {
      // throw new CustomError('Already review this Customer.', 'EF2215_Content');
    }

    const orderHandle = new Orders(privateKey);
    const order = await orderHandle.getOrderByID(orderId);
    if (order.shopAddr === order.cusAddr) {
      throw new CustomError('Cannot review by self.', 'EF2148_Content');
    }

    // add review customer
    const data = await reviewHandle.addReviewToCustomer(orderId, star, comment);

    // Change status of previous notification related to this orderId from customer to Read
    await changeReadStatusNotificationByOrder(
      orderId,
      [NOTIFY_CONTENT_TYPE.CONFIRMED, NOTIFY_CONTENT_TYPE.PAID, NOTIFY_CONTENT_TYPE.RECEIVED],
      [NOTIFY_CATEGORY.PRODUCT_REVIEWS]
    );

    // try {
    //   const resultAddReviewToElastic = await elasticAddreview({
    //     id: data.id,
    //     reviewType: SHOP_REVIEW_CUSTOMER,
    //     orderId: orderId,
    //     star: star,
    //     comment: comment,
    //     sendAddress: reviewHandle.getPublicAddress(),
    //     recipientAddress: data.recipientAddress,
    //     createdAt: new Date(data.createdAt * 1000),
    //     updatedAt: new Date(data.createdAt * 1000)
    //   });
    // } catch (e) {
    //   console.log(e);
    // }
    return {
      status: status_response.success,
      result: {
        data: data,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId || 'EF2075_Content'
      }
    };
  }
};

/**
 * Get detail review by id
 * @param {*} reviewId
 * @return {*} review infomation
 *  * sample data for review:
 * {
 *  comment: "This is my review to shop"
 *  createdAt: 1544500281
 *  recipientAddress: "0xd359a0D9A8613B7FFaf510761720cC83FfAf52EA"
 *  reviewId: 0
 *  reviewType: 1
 *  sendAddress: "0x61DA61fF02a195E5d4b6F7cd0B737Cd7D793Dbc7"
 *  star: 4
 *  updatedAt: 1544500281
 * }
 */
const getDetailReview = async function(reviewId) {
  try {
    checkNumber('reviewId', reviewId);
    let privateKey;
    try {
      privateKey = await getPrivateKey();
    } catch (error) {
      //error
    }
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.getDetailReview(reviewId);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Get list review about a customer
 * @param {*} cusAddr
 * @param {*} page
 * @param {*} limit
 * @param {*} sortByDate 0: old -> new, 1: new -> old
 * @return array of review
 * sample data for review:
 * {
 *  comment: "This is my review to shop"
 *  createdAt: 1544500281
 *  recipientAddress: "0xd359a0D9A8613B7FFaf510761720cC83FfAf52EA"
 *  reviewId: 0
 *  reviewType: 1
 *  sendAddress: "0x61DA61fF02a195E5d4b6F7cd0B737Cd7D793Dbc7"
 *  star: 4
 *  updatedAt: 1544500281
 * }
 */
const getListReviewsCustomer = async function(cusAddr, page, limit, sortByDate = 1) {
  try {
    checkCryptoAddress(cusAddr);
    let privateKey;
    try {
      privateKey = await getPrivateKey();
    } catch (error) {
      //error
    }
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.getListReviewsCustomer(cusAddr, page, limit, sortByDate);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Get list review about shop
 * @param {*} shopAddrees
 * @param {*} page
 * @param {*} limit
 * @param {*} sortByDate 0: old -> new, 1: new -> old
 * @return {*} array of review
 * sample data for review:
 * {
 *  comment: "This is my review to shop"
 *  createdAt: 1544500281
 *  recipientAddress: "0xd359a0D9A8613B7FFaf510761720cC83FfAf52EA"
 *  reviewId: 0
 *  reviewType: 1
 *  sendAddress: "0x61DA61fF02a195E5d4b6F7cd0B737Cd7D793Dbc7"
 *  star: 4
 *  updatedAt: 1544500281
 * }
 */
const getListReviewsShop = async function(shopAddrees, page, limit, sortByDate = 1) {
  try {
    checkCryptoAddress(shopAddrees);
    let privateKey;
    try {
      privateKey = await getPrivateKey();
    } catch (error) {
      //error
    }
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.getListReviewsShop(shopAddrees, page, limit, sortByDate);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Get statistic review about a customer
 * @param {*} cusAddr
 * @return statistic review
 * sample data for statistic review:
 * {
 *   oneStar: 0,
 *   twoStar: 0,
 *   threeStar: 0,
 *   fourStar: 2,
 *   fiveStar: 5
 * }
 */
const getStatisticReviewCustomer = async function(cusAddr) {
  try {
    checkCryptoAddress(cusAddr);
    let privateKey;
    try {
      privateKey = await getPrivateKey();
    } catch (error) {
      //error
    }
    const reviewHandle = new Reviews(privateKey);
    const result = await reviewHandle.getStatisticReviewCustomer(cusAddr);
    return {
      status: status_response.success,
      result: {
        data: result,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Check value is number
 * @param {*} fieldName
 * @param fieldValue
 */
const checkNumber = function(fieldName, fieldValue) {
  if (fieldValue === undefined || fieldValue === null || typeof fieldValue === 'undefined') {
    throw new CustomError(fieldName + ' is require!', 'EF2143_Content');
  }
  //check product id is number
  if (!/^\d+$/.test(fieldValue)) {
    throw new CustomError(fieldName + ' must be a number!', 'EF2143_Content');
  }
};

/**
 * Check valid star
 * @param {*} star
 */
const checkStarInput = function(star) {
  if (star === undefined || star === null || typeof star === 'undefined') {
    throw new CustomError('Star is require!', 'EF2143_Content');
  }
  //check star id is number 1-5
  const starValues = [1, 2, 3, 4, 5];
  if (starValues.indexOf(star) <= -1) {
    throw new CustomError('Star must be a number from 1 to 5!', 'EF2143_Content');
  }
};

/**
 * Check comment is valid
 * @param {*} comment
 */
const checkComment = function(comment) {
  if (comment.length >= 1000) {
    throw new CustomError('comment require less than 1000 characters', 'EF2143_Content');
  }
};

/**
 * Check valid address
 * @param {*} cryptoAddress
 */
const checkCryptoAddress = function(cryptoAddress) {
  if (!cryptoAddress || !cryptoAddress.length) {
    throw new CustomError('cryptoAddress is require!', 'EF2143_Content');
  }
  const isValid = /^(0x){1}[0-9a-fA-F]{40}$/i.test(cryptoAddress);
  if (!isValid) {
    throw new CustomError('cryptoAddress is not valid!', 'EF2143_Content');
  }
};

export {
  checkStatusReviewShop,
  checkStatusReviewCustomer,
  addReviewToShop,
  addReviewToCustomer,
  getDetailReview,
  getListReviewsShop,
  getListReviewsCustomer,
  getStatisticReviewCustomer
};
